import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor() { }

  public isDateDiffLessThanDuration(date, dob, duration) {
    var result = date.diff(dob, 'years', true);
    if(result < duration) {
        return true;
    } else {
        return false;
    }
  }
}
